import _Vue from 'vue';
import Request, { RequestOptions } from '../../lib/request';

export function WxRequestPlugin(Vue: typeof _Vue, options: RequestOptions) {
    Vue.prototype.$request = Request(options);
}
